'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.findWalletByWindowKey = void 0;
var _core = require('@sei-js/core');
var findWalletByWindowKey = (exports.findWalletByWindowKey = function findWalletByWindowKey(windowKey) {
	switch (windowKey) {
		case 'compass':
			return _core.COMPASS_WALLET;
		case 'leap':
			return _core.LEAP_WALLET;
		case 'keplr':
			return _core.KEPLR_WALLET;
		case 'fin':
			return _core.FIN_WALLET;
		default:
			return undefined;
	}
});
//# sourceMappingURL=helpers.js.map
